export const LogoFull = () => {
  return (
    <svg
      width="112"
      height="16"
      viewBox="0 0 112 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M102.651 15.7682H100.146V4.2436H102.442V6.40013H102.535C103.068 5.17114 104.297 4.01172 106.546 4.01172C109.538 4.01172 110.883 5.91317 110.883 8.53346V15.7682H108.378V9.08998C108.378 7.02621 107.729 6.16824 105.619 6.16824C103.578 6.16824 102.651 6.95665 102.651 9.11317V15.7682Z"
        fill="#1A1F23"
      />
      <path
        d="M90.9069 16.0001C88.8432 16.0001 87.2432 14.9335 87.2432 12.9161C87.2432 11.0146 88.6345 10.0175 91.0924 9.66969L95.1272 9.06679V8.44071C95.1272 6.72476 94.3388 6.21462 92.5301 6.21462C90.6982 6.21462 89.9794 6.79433 89.9794 8.32476V8.67259H87.5678V8.44071C87.5678 5.86679 89.5852 4.01172 92.6692 4.01172C95.8924 4.01172 97.5156 5.95954 97.5156 8.76534V15.7682H95.1968V13.9595H95.0808C94.4084 15.0494 93.0866 16.0001 90.9069 16.0001ZM89.6779 12.7306C89.6779 13.6349 90.2577 14.0059 91.7185 14.0059C93.3417 14.0059 95.1272 13.3566 95.1272 11.0378V10.8291L91.4634 11.3856C90.1417 11.5711 89.6779 11.8726 89.6779 12.7306Z"
        fill="#1A1F23"
      />
      <path
        d="M76.5701 15.7677H74.2744V0.231445H76.7788V6.07492H76.8251C77.3353 5.03144 78.657 4.01115 80.6976 4.01115C83.8744 4.01115 85.544 6.35319 85.544 9.99376C85.544 13.6575 83.7817 15.9996 80.5585 15.9996C78.5643 15.9996 77.2193 15.2112 76.6628 13.8662H76.5701V15.7677ZM76.7788 11.0372C76.7788 12.9619 77.8918 13.8662 79.9092 13.8662C82.1353 13.8662 83.0628 12.8459 83.0628 9.99376C83.0628 7.16478 82.1121 6.14449 79.9092 6.14449C77.8918 6.14449 76.7788 7.04884 76.7788 8.97347V11.0372Z"
        fill="#1A1F23"
      />
      <path
        d="M65.0358 16.0001C62.9721 16.0001 61.3721 14.9335 61.3721 12.9161C61.3721 11.0146 62.7634 10.0175 65.2213 9.66969L69.2561 9.06679V8.44071C69.2561 6.72476 68.4677 6.21462 66.659 6.21462C64.8271 6.21462 64.1083 6.79433 64.1083 8.32476V8.67259H61.6967V8.44071C61.6967 5.86679 63.7141 4.01172 66.7982 4.01172C70.0213 4.01172 71.6445 5.95954 71.6445 8.76534V15.7682H69.3257V13.9595H69.2098C68.5373 15.0494 67.2155 16.0001 65.0358 16.0001ZM63.8069 12.7306C63.8069 13.6349 64.3866 14.0059 65.8474 14.0059C67.4706 14.0059 69.2561 13.3566 69.2561 11.0378V10.8291L65.5924 11.3856C64.2706 11.5711 63.8069 11.8726 63.8069 12.7306Z"
        fill="#1A1F23"
      />
      <path
        d="M53.853 15.7682H51.3486V4.17404H53.6443V6.00592H53.7602C54.224 4.93926 55.2907 4.01172 56.9834 4.01172C59.395 4.01172 60.3225 5.77404 60.3225 7.93056V8.69578H57.8182V8.23201C57.8182 6.70157 57.3776 6.14505 55.9167 6.14505C54.4095 6.14505 53.853 6.72476 53.853 8.2552V15.7682Z"
        fill="#1A1F23"
      />
      <path
        d="M43.5847 16.0001C40.0369 16.0001 37.834 13.5885 37.834 9.99433C37.834 6.42331 40.0369 4.01172 43.5847 4.01172C47.1093 4.01172 49.2427 6.42331 49.2427 9.99433C49.2427 13.5885 47.1093 16.0001 43.5847 16.0001ZM43.5847 13.774C45.9963 13.774 46.8311 12.5914 46.8311 9.99433C46.8311 7.42042 45.9963 6.23781 43.5847 6.23781C41.1499 6.23781 40.292 7.42042 40.292 9.99433C40.292 12.5914 41.1499 13.774 43.5847 13.774Z"
        fill="#1A1F23"
      />
      <path
        d="M30.5619 16C26.0865 16 24.1387 13.9362 24.1387 10.9449V10.5507H26.5966V10.8058C26.5966 12.7304 27.4082 13.7043 30.6546 13.7043C32.9503 13.7043 33.785 13.0783 33.785 11.6406C33.785 10.2261 33.3213 9.71594 30.9329 9.22899L28.2894 8.69565C25.6227 8.18551 24.185 6.88696 24.185 4.42899C24.185 2.13333 25.9706 0 29.9822 0C34.272 0 35.9879 2.41159 35.9879 5.17101V5.44927H33.53V5.1942C33.53 3.29275 32.6952 2.29565 29.9126 2.29565C27.6169 2.29565 26.6894 2.94493 26.6894 4.31304C26.6894 5.72754 27.3155 6.12174 29.4488 6.58551L32.0923 7.14203C35.014 7.74493 36.2894 9.2058 36.2894 11.5478C36.2894 13.9826 34.5271 16 30.5619 16Z"
        fill="#1A1F23"
      />
      <path
        d="M10.8832 1.77778C10.8832 2.75962 10.0711 3.55556 9.06935 3.55556C8.06758 3.55556 7.25548 2.75962 7.25548 1.77778C7.25548 0.795938 8.06758 0 9.06935 0C10.0711 0 10.8832 0.795938 10.8832 1.77778Z"
        fill="url(#paint0_linear_77_27310)"
      />
      <path
        d="M10.8832 14.2222C10.8832 15.2041 10.0711 16 9.06935 16C8.06758 16 7.25548 15.2041 7.25548 14.2222C7.25548 13.2404 8.06758 12.4444 9.06935 12.4444C10.0711 12.4444 10.8832 13.2404 10.8832 14.2222Z"
        fill="url(#paint1_linear_77_27310)"
      />
      <path
        d="M3.62774 14.2222C3.62774 15.2041 2.81564 16 1.81387 16C0.812097 16 0 15.2041 0 14.2222C0 13.2404 0.812097 12.4444 1.81387 12.4444C2.81564 12.4444 3.62774 13.2404 3.62774 14.2222Z"
        fill="url(#paint2_linear_77_27310)"
      />
      <path
        d="M18.1387 14.2222C18.1387 15.2041 17.3266 16 16.3248 16C15.3231 16 14.511 15.2041 14.511 14.2222C14.511 13.2404 15.3231 12.4444 16.3248 12.4444C17.3266 12.4444 18.1387 13.2404 18.1387 14.2222Z"
        fill="url(#paint3_linear_77_27310)"
      />
      <path
        d="M7.25548 7.82222C7.25548 8.80406 6.44338 9.6 5.44161 9.6C4.43984 9.6 3.62774 8.80406 3.62774 7.82222C3.62774 6.84038 4.43984 6.04444 5.44161 6.04444C6.44338 6.04444 7.25548 6.84038 7.25548 7.82222Z"
        fill="url(#paint4_linear_77_27310)"
      />
      <path
        d="M14.511 7.82222C14.511 8.80406 13.6989 9.6 12.6971 9.6C11.6953 9.6 10.8832 8.80406 10.8832 7.82222C10.8832 6.84038 11.6953 6.04444 12.6971 6.04444C13.6989 6.04444 14.511 6.84038 14.511 7.82222Z"
        fill="url(#paint5_linear_77_27310)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_77_27310"
          x1="9"
          y1="1.5"
          x2="18"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2024" />
          <stop offset="1" stopColor="#1B2024" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_77_27310"
          x1="9"
          y1="1.5"
          x2="18"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2024" />
          <stop offset="1" stopColor="#1B2024" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_77_27310"
          x1="9"
          y1="1.5"
          x2="18"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2024" />
          <stop offset="1" stopColor="#1B2024" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_77_27310"
          x1="9"
          y1="1.5"
          x2="18"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2024" />
          <stop offset="1" stopColor="#1B2024" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_77_27310"
          x1="9"
          y1="1.5"
          x2="18"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2024" />
          <stop offset="1" stopColor="#1B2024" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_77_27310"
          x1="9"
          y1="1.5"
          x2="18"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2024" />
          <stop offset="1" stopColor="#1B2024" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
